// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}
ion-radio-group ion-item {
  background: #ffffff;
  border-radius: var(--radius-default);
  border: var(--outline-default);
  border-width: 2px;
  margin-bottom: 4px;
  --ion-font-family: AppFontMedium;
  font-size: 13px;
  line-height: 16px;
  line-height: 100%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-black);
}
ion-radio-group ion-item.selected {
  border: 2px solid #05121a;
}

.price {
  font-family: AppFontSemiBold;
  font-size: 14px;
  color: var(--ion-color-black);
  text-align: end;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

.pfand {
  font-size: 10px;
}

ion-checkbox {
  --background: transparent;
  --background-checked: var(--ion-color-primary);
  --border-color: var(--ion-color-primary-shade);
  --border-color-checked: var(--ion-color-primary);
  --border-width: 1px;
  --checkmark-color: var(--ion-color-primary-contrast);
  --checkmark-width: 2px;
  --border-radius: var(--radius-default);
  --checkbox-background: transparent;
  --size: 20px;
}

app-tag {
  display: inline-flex;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;AACC;EACC,mBAAA;EACA,oCAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EAMA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,yBAAA;AALF;AAOE;EACC,yBAAA;AALH;;AAUA;EACC,4BAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;AAPD;;AAaA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AAVD;;AAaA;EACC,qBAAA;AAVD;;AAaA;EACC,eAAA;AAVD;;AAaA;EACC,yBAAA;EACA,8CAAA;EACA,8CAAA;EACA,gDAAA;EACA,mBAAA;EACA,oDAAA;EACA,sBAAA;EACA,sCAAA;EACA,kCAAA;EACA,YAAA;AAVD;;AAaA;EACC,oBAAA;EACA,iBAAA;AAVD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n\n\tion-item {\n\t\tbackground: #ffffff;\n\t\tborder-radius: var(--radius-default);\n\t\tborder: var(--outline-default);\n\t\tborder-width: 2px;\n\t\tmargin-bottom: 4px;\n\n\t\t// &:first-child {\n\t\t// \tborder-top: var(--outline-default);\n\t\t// }\n\n\t\t--ion-font-family: AppFontMedium;\n\t\tfont-size: 13px;\n\t\tline-height: 16px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0.02em;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\tcolor: var(--color-black);\n\n\t\t&.selected {\n\t\t\tborder: 2px solid #05121a;\n\t\t}\n\t}\n}\n\n.price {\n\tfont-family: AppFontSemiBold;\n\tfont-size: 14px;\n\tcolor: var(--ion-color-black);\n\ttext-align: end;\n}\n\nion-label {\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n\nion-checkbox {\n\t--background: transparent;\n\t--background-checked: var(--ion-color-primary);\n\t--border-color: var(--ion-color-primary-shade);\n\t--border-color-checked: var(--ion-color-primary);\n\t--border-width: 1px;\n\t--checkmark-color: var(--ion-color-primary-contrast);\n\t--checkmark-width: 2px;\n\t--border-radius: var(--radius-default);\n\t--checkbox-background: transparent;\n\t--size: 20px;\n}\n\napp-tag {\n\tdisplay: inline-flex;\n\tmargin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
